import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getToken, getRefreshToken } from '@/utils/common';

export type AuthState = {
  user: UserProfile | null;
  token?: string | null;
  refreshToken?: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
};

export const authInitialState: AuthState = {
  user: null,
  token: getToken(),
  refreshToken: getRefreshToken(),
  isAuthenticated: !!getToken(),
  isLoading: false,
};

const slice = createSlice({
  name: 'auth',
  initialState: authInitialState,
  reducers: {
    clearAuthDataAction(state) {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
    },

    setDataAndTokenAction(
      state,
      {
        payload,
      }: PayloadAction<{
        user?: UserProfile | null;
        token?: string | null;
        refreshToken?: string | null;
        isAuthenticated?: boolean;
      }>,
    ) {
      if (payload.user !== undefined) {
        state.user = payload.user;
      }
      if (payload.token !== undefined) {
        state.token = payload.token;
      }
      if (payload.refreshToken !== undefined) {
        state.refreshToken = payload.refreshToken;
      }
      if (payload.isAuthenticated !== undefined) {
        state.isAuthenticated = payload.isAuthenticated;
      }
    },

    setLoadingAction(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload;
    },

    setUserAction(state, { payload }: PayloadAction<UserProfile | null>) {
      state.user = payload;
      state.isAuthenticated = !!payload;
    },

    editUserProfileAction(state, { payload }: PayloadAction<Partial<UserProfile>>) {
      if (state.user) {
        state.user = { ...state.user, ...payload };
      }
    },

    updateTokensAction(
      state,
      { payload }: PayloadAction<{ token?: string | null; refreshToken?: string | null }>,
    ) {
      if (payload.token !== undefined) {
        state.token = payload.token;
      }
      if (payload.refreshToken !== undefined) {
        state.refreshToken = payload.refreshToken;
      }
      state.isAuthenticated = !!payload.token;
    },
  },
});

export const {
  clearAuthDataAction,
  setDataAndTokenAction,
  setLoadingAction,
  setUserAction,
  editUserProfileAction,
  updateTokensAction,
} = slice.actions;
export default slice.reducer;
